export {default} from './BenefitsInvestigation';